import { render } from "./TeacherClass.vue?vue&type=template&id=27ae1fcc&scoped=true"
import script from "./TeacherClass.vue?vue&type=script&lang=js"
export * from "./TeacherClass.vue?vue&type=script&lang=js"

import "./TeacherClass.vue?vue&type=style&index=0&id=27ae1fcc&lang=less&scoped=true"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ae1fcc"]])

export default __exports__